import { z } from 'zod';
import { ObjectIdSchema } from '../../shared/object-id.schema';
import { DraftNodeEnvelopeSchema } from '../../entities/process-draft';
/**
 * POST /api/v2/process/:id/draft/steps/bulk-delete
 *
 * Batch companion to the single-step DELETE. One request deletes the whole
 * selection: issuing one HTTP request per step (plus the two cache-refetch
 * GETs each mutation triggers) tripped the API-wide rate limit on large
 * selections, aborting the batch halfway and leaving steps behind.
 *
 * `stepIds` are draft-step document `_id`s (same identifier space as the
 * single-delete route). The cap mirrors the layout contracts' 500-node
 * ceiling — a draft never legitimately exceeds it.
 */ export const DeleteDraftStepsRequestSchema = z.object({
    stepIds: z.array(ObjectIdSchema).min(1).max(500)
});
/**
 * The bulk delete never fails the whole batch over one bad step: request ids
 * that resolve to nothing (deleted by a concurrent editor) are skipped and a
 * mid-batch cascade error stops the loop but keeps what already succeeded.
 * The response therefore reports three disjoint outcomes on top of the
 * uniform envelope so the client can reconcile the survivors AND tell the
 * user what didn't happen:
 * - `deletedNodeIds` (envelope) — stableStepIds actually removed
 * - `notFoundStepIds` — request `_id`s that no longer resolved to a step
 * - `failedStepIds` — the request `_id` whose cascade errored plus every id
 *   after it that was consequently never attempted
 */ export const DeleteDraftStepsResponseSchema = DraftNodeEnvelopeSchema.extend({
    notFoundStepIds: z.array(ObjectIdSchema),
    failedStepIds: z.array(ObjectIdSchema)
});

//# sourceMappingURL=delete-draft-steps.schema.js.map